import 'react';
import { BsCameraVideo } from '@react-icons/all-files/bs/BsCameraVideo';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Video as Video$1 } from './Video.js';
import { VideoInspector } from './Video.Inspector.js';
import { jsx } from '@emotion/react';

var Video = decorateComponent(Video$1, 'block', {
  id: 'video',
  label: '비디오',
  defaultProps: {
    loop: false,
    muted: true,
    autoplay: true
  },
  allowedChildren: [],
  disallowedAncestors: ['a', 'coupon', 'tabButton'],
  renderIcon: function renderIcon() {
    return jsx(BsCameraVideo, null);
  },
  renderInspector: VideoInspector
});

export { Video as default };
//# sourceMappingURL=index.js.map
